import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminPanel from './components/AdminPanel';
import AuthProvider from './contexts/AuthContext';
import './App.css';

function App() {
  // Handle iframe-specific setup
  useEffect(() => {
    // Check if running in an iframe
    const isEmbedded = window.self !== window.top;
    
    if (isEmbedded) {
      // Notify parent that admin panel is loaded
      window.parent.postMessage({ type: 'ADMIN_LOADED' }, '*');
      
      // Add event listener for resize messages if needed
      const handleParentMessage = (event: MessageEvent) => {
        // In production, verify the origin
        // if (event.origin !== 'https://your-parent-domain.com') return;
        
        // Handle any specific messages from parent
        console.log('Message from parent:', event.data);
      };
      
      window.addEventListener('message', handleParentMessage);
      return () => window.removeEventListener('message', handleParentMessage);
    }
  }, []);

  return (
    <div className="app-container">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
